import React, {useState} from 'react'
import {UncontrolledTooltip} from 'reactstrap'
import RegenerateIcon from '../../../../../../../assets/icons/icon-reload.svg'
import DownloadIcon from '../../../../../../../assets/icons/icon-download-background.svg'
import CreditInfo from './CreditInfo'
import LoginPromptModal from './LoginPromptModal'
import {downloadImagesAsZip} from '../../../../../../../helpers/downloadZip'

const ResultsGrid = ({ selectAll, onToggleSelectAll, items, onToggleSelect, onDownload, onRegenerate, onImageLoaded, config, tokenInfo, isLoggedIn }) => {
    const hasItems = Array.isArray(items) && items.length > 0
    const itemCount = items.length
    const [isLoginPromptOpen, setIsLoginPromptOpen] = useState(false)
    
    // Determine grid layout class based on item count
    const getGridLayoutClass = () => {
        if (itemCount === 1) return 'results-grid-1'
        if (itemCount === 2) return 'results-grid-2'
        if (itemCount === 3) return 'results-grid-3'
        if (itemCount === 4) return 'results-grid-4'
        return 'results-grid-default' // fallback for more than 4
    }

    const handleOnClickLoginNow = () => {
        setIsLoginPromptOpen(true)
    }

    const handleLogin = () => {
        setIsLoginPromptOpen(false)
        window.location.href = `${process.env.REACT_APP_BASE_URL}/login`
    }

    const handleDownloadAndLogin = async () => {
        if (!hasItems || items.length === 0) {
            handleLogin()
            return
        }

        try {
            await downloadImagesAsZip(items, 'ai-backgrounds.zip', 'background_')
            
            // Navigate to login after a short delay to ensure download starts
            setTimeout(() => {
                handleLogin()
            }, 500)
        } catch (error) {
            console.error('Failed to create zip file:', error)
            // If zip creation fails, just navigate to login
            handleLogin()
        }
    }
    
    return (
        <div>
            <CreditInfo
                config={config}
                tokenInfo={tokenInfo}
                isLoggedIn={isLoggedIn}
                onLoginClick={handleOnClickLoginNow}
            />
            {hasItems && (
                <div className="d-flex align-items-center gap-2 mb-3 mt-3">
                    <input id="cb-select-all" type="checkbox" checked={selectAll} onChange={onToggleSelectAll} />
                    <label htmlFor="cb-select-all" className="m-0">Select all</label>
                </div>
            )}
            {!hasItems && (
                <div className="NoResults text-center text-muted py-4">No image generated</div>
            )}
            {hasItems && (
            <div className={`results-grid-container ${getGridLayoutClass()}`}>
                {items.map((item) => {
                    const regenerateButtonId = `regenerate-btn-${item.id}`
                    return (
                    <div key={item.id} className="results-grid-item">
                        <div className={`GeneratedCard ${item.selected ? 'is-selected' : ''} ${item.regenerating ? 'is-regenerating' : ''}`}>
                            <div
                                className="GeneratedCardMedia"
                                role="button"
                                tabIndex={0}
                                onClick={() => {
                                    if (item.regenerating) return
                                    onToggleSelect(item.id)
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        if (item.regenerating) return
                                        onToggleSelect(item.id)
                                    }
                                }}
                            >
                                <img
                                    src={item.url}
                                    alt="generated background"
                                    className="GeneratedImage"
                                    onLoad={() => {
                                        if (item.regenerating && onImageLoaded) {
                                            onImageLoaded(item.id)
                                        }
                                    }}
                                />
                                {item.selected && <div className="SelectedOverlay" aria-hidden="true" />}
                                {item.regenerating && (
                                    <>
                                        <div className="RegeneratingOverlay" />
                                        <div className="RegeneratingSpinnerWrapper">
                                            <div className="RegenerateSpinner" />
                                        </div>
                                    </>
                                )}
                            </div>
                            {!item.selected && (
                                <button
                                    type="button"
                                    className="CardAction CardAction-left"
                                    id={regenerateButtonId}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        if (onRegenerate && !item.regenerating) {
                                            onRegenerate(item.id, item.url)
                                        }
                                    }}
                                    disabled={item.regenerating}
                                >
                                    <img src={RegenerateIcon} alt="Regenerate" />
                                </button>
                            )}
                            {!item.selected && (
                                <UncontrolledTooltip
                                    placement="top"
                                    target={regenerateButtonId}
                                    popperClassName="custom-tooltip-regenerate"
                                >
                                    <span>Re-generate this background</span>
                                </UncontrolledTooltip>
                            )}
                            <button
                                type="button"
                                className="CardAction CardAction-right"
                                title="Download"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    if (item.regenerating) return
                                    onDownload(item.url)
                                }}
                                disabled={item.regenerating}
                            >
                                <img src={DownloadIcon} alt="Download" />
                            </button>
                            <div className="CardCheckbox">
                                <input
                                    type="checkbox"
                                    checked={!!item.selected}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={() => {
                                        if (item.regenerating) return
                                        onToggleSelect(item.id)
                                    }}
                                    disabled={item.regenerating}
                                />
                            </div>
                        </div>
                    </div>
                )})}
            </div>
            )}
            <LoginPromptModal
                isOpen={isLoginPromptOpen}
                toggle={() => setIsLoginPromptOpen(false)}
                onLogin={handleLogin}
                onDownloadAndLogin={handleDownloadAndLogin}
                onPurchase={() => {
                    console.log('[ResultsGrid] Purchase clicked')
                    setIsLoginPromptOpen(false)
                }}
                items={items}
                isLoggedIn={isLoggedIn}
            />
        </div>
    )
}

export default ResultsGrid


